import React from 'react';

export default function ProjectGitHub(props?: SVGProps) {
	return (
		<svg viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
			<g clipPath='url(#clip0_2192_160)'>
				<path
					d='M9.33322 12.8493V11.1751C9.3551 10.897 9.31752 10.6173 9.22297 10.3548C9.12843 10.0923 8.97909 9.85295 8.78488 9.65262C10.6165 9.44846 12.5415 8.75429 12.5415 5.56929C12.5414 4.75485 12.2281 3.97165 11.6665 3.38179C11.9325 2.66925 11.9137 1.88166 11.614 1.18262C11.614 1.18262 10.9257 0.978455 9.33322 2.04595C7.99622 1.6836 6.58688 1.6836 5.24988 2.04595C3.65738 0.978455 2.96905 1.18262 2.96905 1.18262C2.66943 1.88166 2.65063 2.66925 2.91655 3.38179C2.35079 3.97603 2.03719 4.76631 2.04155 5.58679C2.04155 8.74845 3.96655 9.44262 5.79821 9.67012C5.6063 9.86844 5.45829 10.1049 5.36381 10.3642C5.26934 10.6235 5.23052 10.8998 5.24988 11.1751V12.8493'
					className='theme-stroke'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
				<path
					d='M5.25008 11.6826C3.50008 12.2502 2.04175 11.6826 1.16675 9.93262'
					className='theme-stroke'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
			</g>
			<defs>
				<clipPath id='clip0_2192_160'>
					<rect width='14' height='14' fill='white' />
				</clipPath>
			</defs>
		</svg>
	);
}
